export default {
      id: "common__info_link-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__info_link",
      toString: function () {
        return this.url;
      }
    }